import angular from 'angular';
import tableGridAccordionToggleCellComponent from './tableGridAccordionToggleCell.component';

let tableGridAccordionToggleCellModule = angular.module('tableGridAccordionToggleCell', []).directive('tableGridAccordionToggleCell', tableGridAccordionToggleCellComponent);

export default tableGridAccordionToggleCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridAccordionToggleCell/tableGridAccordionToggleCell.js